import React, { useEffect } from 'react';
import { DownloadOrdersProps } from './types';
import { AllDownload } from '@vtbhome/juicyfront/indexIcon';
import { useDownloadOrdersMutation } from '../api/download-oreders-api';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { StyledButton } from './download-orders.styles';

export const DownloadOrders: React.FC<DownloadOrdersProps> = () => {
    const [downloadOrders, downloadOrdersResult] = useDownloadOrdersMutation();
    const isLoading = downloadOrdersResult.isLoading;

    const handleClick = () => {
        downloadOrders({});
    };

    useEffect(() => {
        if (downloadOrdersResult.isSuccess) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description='Сделки выгружены'
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            downloadOrdersResult.reset();
        } else if (downloadOrdersResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось выгрузить сделки.\n${getQueryError(downloadOrdersResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            downloadOrdersResult.reset();
        }
    }, [downloadOrdersResult.isSuccess, downloadOrdersResult.isError]);

    return (
        <StyledButton
            disabled={isLoading}
            preloader={isLoading}
            buttonType='round'
            size='m'
            startAdornment={<AllDownload />}
            onClick={handleClick}
        />
    );
};
